import { Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import useBreadcrumbs from "hooks/useBreadcrumbs/useBreadcrumbs";

/**
 * Renders a dynamic breadcrumb bar driven by the route config + BreadcrumbContext.
 * Rendered once in MainLayout — never hardcoded per page.
 * Hidden on top-level pages (only 1 crumb).
 */
export default function AppBreadcrumb() {
  const crumbs = useBreadcrumbs();

  if (crumbs.length <= 1) return null;

  const items = crumbs.map((crumb, i) => {
    const isLast = i === crumbs.length - 1;
    return {
      title: isLast ? (
        crumb.label
      ) : (
        <Link to={crumb.path}>{crumb.label}</Link>
      ),
    };
  });

  return <Breadcrumb items={items} style={{ marginBottom: 16 }} />;
}
